import { render, staticRenderFns } from "./preset-book-init.component.vue?vue&type=template&id=6d157d96&scoped=true"
import script from "./preset-book-init.component.vue?vue&type=script&lang=ts"
export * from "./preset-book-init.component.vue?vue&type=script&lang=ts"
import style0 from "./preset-book-init.component.vue?vue&type=style&index=0&id=6d157d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d157d96",
  null
  
)

export default component.exports